"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorageValue = void 0;
var react_1 = require("react");
var use_window_event_1 = require("../use-window-event/use-window-event");
function useLocalStorageValue(_a) {
    var key = _a.key, _b = _a.defaultValue, defaultValue = _b === void 0 ? null : _b;
    var _c = react_1.useState(typeof window !== 'undefined' && 'localStorage' in window
        ? window.localStorage.getItem(key)
        : defaultValue), value = _c[0], setValue = _c[1];
    var setLocalStorageValue = function (val) {
        if (typeof val === 'function') {
            setValue(function (current) {
                var result = val(current);
                window.localStorage.setItem(key, result);
                return result;
            });
        }
        else {
            window.localStorage.setItem(key, val);
            setValue(val);
        }
    };
    use_window_event_1.useWindowEvent('storage', function (event) {
        if (event.storageArea === window.localStorage && event.key === key) {
            setValue(event.newValue);
        }
    });
    return [value, setLocalStorageValue];
}
exports.useLocalStorageValue = useLocalStorageValue;
